import ContentOverlay from "../components/content_overlay";
import { Link } from "react-router-dom";

const styles = {
  cell: {
    border: "1px solid #000",
    padding: "4px",
    textAlign: "center",
    verticalAlign: "middle",
  },
};

function RADPage() {
  return (
    <ContentOverlay
      heading={
        <h2
          style={{
            textAlign: "center",
            fontFamily: "Nunito",
          }}
        >
          {" "}
          <b>Results and Discussion</b>
        </h2>
      }
      text_content={
        <div>
          <p
            className="container"
            style={{
              fontSize: "0.8em",
              fontFamily: "Nunito",
            }}
          >
            <h5>Understanding LU dynamics</h5>
            <p>
              The reliable spatial data available at regular intervals from
              spaceborne sensors have helped to understand forest cover dynamics
              and underlying anthropogenic pressures. LU analysis highlights the
              loss of evergreen forest cover of 5% with an increase of built-up
              cover (4.5%), and agriculture area (9%) due to anthropogenic
              pressures (Figure 3). The evergreen forest cover has reduced from
              16% (in 1985) to 11% (in 2018). The decline in native forests is
              due to unplanned anthropogenic activities involving the
              construction of a series of hydroelectric projects, indiscriminate
              mining, and unscientific afforestation of monoculture plantations
              (Acacia, Rubber, Eucalyptus, Teak), etc. Mining activities in the
              hilly and undulating terrains are disrupting the hydrologic
              regime, continuous forest patches, and ecological footprints
              beyond the physical boundaries of mines. In the past two decades,
              recurring instances of floods and landslides were noticed due to
              abrupt LULC changes across the Ghats, especially in Kerala, and
              Karnataka states(Ramachandra et al. 2021). The water-holding
              capacity is of the soil is affected by LULC changes, resulting in
              flash floods across the states. Fragmentation analyses highlight
              the status of forests in the Western Ghats. Over the past three
              decades, interior forest cover has reduced from 37.14 to 25.01%.
              The loss of interior cover (12.2%) with an increase of non-forest
              cover (11.3%) from 1985 to 2018 represents an escalation in
              fragmentation, which has affected local ecology, leading to
              habitat loss, and impacting many forest-dependent biotas. The
              interior forests are mainly situated in protected areas across the
              region. The decline of the contiguous interior forests affects
              endemic taxa and habitats, resulting in the loss of life and
              property with higher recurring instances of human-wildlife
              conflicts.
            </p>
            <p style={{ textAlign: "center" }}>
              {" "}
              <img src="images/wgb3.png" alt="" />{" "}
            </p>

            <p style={{ textAlign: "center" }}>
              Figure 3. LU dynamics of the Western Ghats
            </p>
            <h5>Prioritization of ESR and recommendations for conservation</h5>
            <p>
              ESR is prioritized at disaggregated levels based on the extent and
              condition of an ecosystem by integrating bio, geo-climatic, land
              cover, condition of ecosystems (fragmentation), ecological,
              hydrological, and social variables with the assignment of weights.
            </p>
            <h5>Landscape status</h5>
            <p>
              The extent and condition (fragmentation) of forests depict the
              landscape status. Spatiotemporal analyses of LU indicate a
              significant loss in the forest cover across the states of
              Maharashtra, eastern parts of Tamil Nadu, western parts of Kerala,
              and Goa. Current forest cover is confined to well-managed reserve
              forests, and protected areas (Pas) corresponding to the Western
              Ghats region in Karnataka and Kerala that have &gt; 60% forest
              cover and contiguous or intact forests (&gt;60% extent).
            </p>
            <p>
              Species distribution across the latitudinal gradient highlights
              the higher occurrence of endemic trees and fauna species at
              10-14&deg; latitudes corresponding to the Kerala and Karnataka
              portions of the Western Ghats regions (Figures 4 and 5). The
              spatial distribution of species across the latitudinal range
              signifies the necessity of conserving habitats of endemic species
              to avoid further degradation. The fragmentation in the Western
              Ghats will adversely impact this unique gene pool. The loss of
              continuity of forest animals tends to reside in small fragments,
              restrict movement to relatively narrow bands around the forest
              edges, and prefer inbreeding. The consequences of fragmentation on
              biodiversity include a lower growth rate of species due to
              resource shortage or dietary diversity, disruption of genetic
              exchanges amongst wildlife populations, and a significantly high
              mortality rate.
            </p>
            <p style={{ textAlign: "center" }}>
              {" "}
              <img src="images/wgb4.png" alt="" />{" "}
            </p>

            <p style={{ textAlign: "center" }}>
              Figure 4. Endemic species of flora across a latitudinal gradient
              in the Western Ghats
            </p>
            <p style={{ textAlign: "center" }}>
              {" "}
              <img src="images/wgb5.png" alt="" />{" "}
            </p>

            <p style={{ textAlign: "center" }}>
              Figure 5. Endemic species of fauna across a latitudinal gradient
              in the Western Ghats
            </p>
            <p>
              The Western Ghats is the hottest hotspot of biodiversity and has
              been experiencing land degradation and deforestation due to higher
              loss of forest cover since independence with unplanned
              developmental activities and fragmented governance. Many carnivore
              taxa are now confined in small fragments leading to escalation in
              human-animal conflicts apart from the inbreeding pressure and
              extirpation of the viable gene (Ramachandra and Bharath 2019c).
              Especially, endemic taxa such as Lion-Tailed Macaques are
              experiencing higher predation due to loss of contiguity in the
              canopy with the fragmentation of forests.
            </p>
            <h5>Ecology</h5>
            <p>
              Ecological status has been assessed by considering species
              endemism (flora, fauna), threat status of species, the spatial
              extent of protected areas, carbon sequestration potential (based
              on biomass and soil carbon), etc. Biodiversity in the ecologically
              fragile Western Ghats is accounted for through field
              investigations coupled with the data mining of published
              literature and- research papers published in peer-reviewed
              international journals, biodiversity portals (of the respective
              states), administration reports, and forest department management
              plans. The Western Ghats biodiversity database has 29047 records
              covering flora species across diverse forest types
              (https://wgbis.ces.iisc.ac.in/biodiversity/database_new/), which
              is compiled based on field investigation and the review of 450
              literature. The fauna database has 13878 records covering multiple
              categories (taxa) collected through the literature review (400
              literature). The data analyses reveal that the Western Ghats are
              endowed with rich biodiversity, evident from the occurrence of
              5000+ species of flowering plants (38% endemics), 330 butterflies
              (11% endemics), 197 reptiles (62% endemics), 529 birds (4%
              endemics), 161 mammals (12% endemics), 335 fishes (41% endemics)
              and 248 amphibians (75% endemics). Hence, conserving ecologically
              sensitive regions is essential for sustaining diverse food and
              medicine. Endemism and IUCN (International Union for Conservation
              of Nature) conservation status is considered with respect to flora
              and fauna variables. Endemic flora includes{" "}
              <em>
                Hopea erosa, Vateria indica, Poeciloneuron pauciflorum,
                Memecylon sisparense, Actinodaphne campanulata, Actinodaphne
                lanata, Artocarpus hirsutus, Cinnamomum agasthyamalayanum,
                Cinnamomum malabatrum, Diospyros atrata, Litsea bourdillonii,
                Litsea hookeri, Symplocos anamallayana, Psychotria globicephala.
                Holigarna grahamii
              </em>
              , etc., which are mostly confined to the southern Western Ghats.
              Weights were assigned to grids based on the frequency distribution
              of endemic species considering mean (&micro;) and standard
              deviation (&sigma;)as 10 for grids with endemic/threatened species
              &gt;&micro;+2&sigma;, 8 for grids with endemic/threatened species
              in the range &micro;+2&sigma; and &micro;+&sigma;, 6 for grids of
              endemic/ threatened species &micro;+&sigma; and &micro;, 4 for
              grids with endemic/ threatened species &lt; &micro;, and 2 for
              grids with the prevalence of only non-endemic species. The central
              and southern Western Ghats account for 227+ endemic trees
              belonging to 37 families. The dominant families of endemic flora
              include Rubiaceae, Lauraceae, Anacardiaceae, Meliaceae, etc.
              Critically endangered and vulnerable fauna includes{" "}
              <em>
                Gonoproktopterus thomassi, Horalabiosa arunachalami, Indira
                nagundia, Rhacophorus pseudomalabaricus, Fejervarya murthii,
                Philautus kaikatti, Ardeotis nigriceps, Cnemaspis sisparensis,
                Gyps indicus, Martes gwatkinsii, Macaca Silenus, Millardia
                kondana, Viverra civettina,
              </em>{" "}
              etc.
            </p>
            <p>
              National Parks, Wildlife Sanctuaries, Conservation Reserves, etc.,
              are intended to conserve the sensitive flora/fauna under the
              protected area (PA) network through a regulatory
              framework(Ramachandra et al. 2018b). PAs have been notified under
              the provisions of the Wild Life (Protection) Act, 1972, and
              management is governed considering the anthropogenic pressure on
              wildlife and other threatened taxa by a set of environmental
              legislation such as the Indian Forest Act, 1927, Forest
              (Conservation) Act, 1980, Environment (Protection) Act, 1986 and
              Biological Diversity Act, 2002, the Scheduled Tribes and Other
              Traditional Forest Dwellers (Recognition of Forest Rights) Act,
              2006, etc. PA network constitutes a protected corridor for
              wildlife, connecting two or more habitat patches previously
              connected but isolated due to forest fragmentation and
              anthropogenic activities. The Western Ghats region has about 7953
              km<sup>2</sup> under PAs, constituting 5% of its geographical
              area, of which 39 are major PAs. They are safeguarding numerous
              species and shielding them from extinction. Nilgiri Biosphere
              Reserve (NBR) with a spatial extent of 5000 km<sup>2 </sup>spread
              across the Western Ghats regions of three states (Kerala,
              Karnataka, and Tamil Nadu). NBR consists of the Western Ghat's
              highest mountain peaks and plateaus, with an elevation ranging
              from 1700-2600 m and 500-7000 mm rainfall. The mountain tops in
              these regions supporting a wide variety of biota are covered with
              grasslands of diverse species. Clumps of evergreen species with
              stunted trees, popularly known as &ldquo;sholas,&rdquo; are
              present in the valleys. NBR region alone has 3,300 angiosperm
              species, of which 132 are endemic, and 19 are listed in the IUCN
              Red List of threatened species.
            </p>
            <p>
              Carbon sequestration is another key ecosystem variable that
              reveals an ecological process, quantified by considering
              above-ground and below-ground biomass across various forest
              ecosystems. Biomass was assessed based on (i) vegetation survey:
              through transect cum quadrat sampling techniques with the
              field-based measurements of GBH (girth at 130 cm) collected across
              the forests of the Western Ghats, (ii) published literature: based
              on the standard experiments covering aboveground biomass,
              below-ground biomass estimations. Field estimations were carried
              out across the diverse forest types covering around 300 transects
              in Uttara Kannada, Shimoga, Chikmagalur, Kodagu, Dakshina Kannada,
              and Udupi. Empirical equations used for biomass estimation across
              forest cover types are based on field experiments integrated with
              literature (Ramachandra and Bharath 2019a). Carbon sequestration
              is accounted as50% of the biomass.
            </p>
            <h5>Geo-Climate</h5>
            <p>
              Topography and climatic factors such as elevation, slope,
              lithology, geology, temperature, and rainfall play a crucial role
              in maintaining the moisture of a forest landscape and influencing
              species diversity. The Western Ghats have eight distinct soil
              groups of highly productive types that support diverse vegetation
              and agriculture activities. Regions with steep slopes and high
              altitudes are vulnerable, and large-scale land cover changes
              induce higher mudslides and landslides, likely to be eroded more
              easily through a trigger of high-intensity rainfall. Incidentally,
              these least resilient regions constitute a vital habitat to
              diverse biota (flora and fauna) and are ecologically fragile or
              environmentally sensitive.
            </p>
            <p>
              Regional climatic conditions are expressed by rainfall and
              temperature variables, which can play a decisive role in
              determining community structure, functions, and species
              distributions (Peters et al. 2012). Rainfall is considered a
              critical and limiting factor regarding forested landscapes in
              terms of the community composition and structure (Bell et al.
              2014). The average rainfall and temperature are assessed using
              Global databases (NCAR and Princeton University) and validated
              through comparison with the surface measurements of ground-based
              monitoring stations of the regional climate datasets (IMD,
              KSNDMC), which show 90% similarities. Temperature shows many
              variations across the grids, and rainfall analysis shows that the
              central Western Ghats receives an average rainfall of over 2500 mm
              and tends to decline to less than 1500 mm towards northern
              portions. Montane rain forests cover the southern regions,
              tropical and subtropical moist broadleaf forests at the western
              slopes, and rainfall ranges from 3500 mm to 7000 mm per year.
            </p>
            <h5>Hydrology</h5>
            <p>
              Forest landscapes with native species of vegetation in the Western
              Ghats aid as hydrological reserves catering to the ecological and
              societal water demand of Peninsular India. The sustained
              anthropogenic pressure on the fragile ecosystems in the Western
              Ghats affects the physical integrity, biota, hydrological regimes,
              bio-geo-chemical relationships, etc., resulting in water and food
              security affecting people's livelihood. With the relatively higher
              forest cover, the Ghats (hilly) region of the Western Ghats is
              endowed with perennial streams and rivers. In contrast, the
              eastern portions, the transition zone of Ghats, and plain lands
              dominated by monoculture plantations are with intermittent and
              seasonal streams of 4 to 6 months water availability(Ramachandra
              et al. 2020b). The absence of intact or contiguous native forests
              and the prevalence of patch and edge forests (with fragmentation)
              in the socially active regions (increased unplanned developmental
              activities with urbanization, industries, etc.) have altered the
              hydrologic regime evident from the decline of rainfall and
              sustenance of water (perennial to seasonal or intermittent).The
              streams are perennial when their catchment is dominated by
              vegetation (&gt; 60%) of native species, mainly due to
              infiltration or percolation in the catchment, as the soil is
              porous with native species. Diverse microorganisms interact with
              plant roots and soil, which helps transfer nutrients from the soil
              to plants, and the soil is porous or permeable. Analyses of soil
              samples from the catchment of perennial and intermittent streams
              reveal that soil in the perennial stream's catchment has the
              highest moisture content (61.47 to 61.57%), and higher nutrients
              (C, N, and K), lower bulk density (0.50 to 0.57 g/cc). In a
              catchment of intermittent and seasonal streams, the soil had a
              higher bulk density (0.87 &ndash; 1.53 g/cc) and relatively lower
              nutrients (Ramachandra et al. 2020b).
            </p>
            <p>
              The major peninsular rivers like the Godavari, Krishna, and
              Cauvery originate in the Western Ghats and flow across the country
              along with their numerous tributaries and finally discharge into
              the Bay of Bengal. The west-flowing rivers are equally productive
              and support the rich biota (flora, fauna), agriculture (croplands
              and horticulture) activities, and finally, discharge into the
              Arabian Sea. The numerous streams in the mountainous parts of the
              Western Ghats draw a large quantum of water to the main rivers.
              The stream frequency, i.e., the number of stream segments per unit
              drainage area (usually per square kilometer), is assessed to
              understand the density of the streams across the grids, which also
              indicates the water availability and condition of the basin.
              Higher stream frequency with rich native vegetation increases
              permeability and infiltration capacity.
            </p>
            <p>
              A comparative assessment of people&rsquo;s livelihood has been
              made with soil water properties and water availability in the
              respective catchment across four river basins in the central
              Western Ghats (Ramachandra et al. 2020b). The result shows that
              streams are perennial when the catchment is covered with &gt; 60%
              vegetation of native species, which have higher soil moisture and
              groundwater than catchments (of seasonal streams) during dry
              spells. The higher soil moisture due to water availability during
              all seasons facilitates the farming of commercial crops with
              higher economic returns to the farmers, unlike the farmers who
              face water crises during the lean season. The study emphasizes the
              need for conservation endeavour on maintaining native vegetation
              in the catchment, highlighting its potential to support
              people&rsquo;s livelihood with water conservation at local and
              regional levels. Both plantation and agricultural crops are
              considered for the valuation in the select catchments of perennial
              and seasonal streams. Plantation crops (viz. areca nut, coconut,
              banana, beetle leaf, and pepper) are the major income-generating
              products in the catchment of perennial streams. A total amount of
              Rs. 3,11,701 ha<sup>-1</sup> yr.<sup>-1</sup> (year 2009-10) gross
              average income was generated from the plantation crops against an
              average expenditure of Rs. 37,043 ha<sup>-1</sup> yr.<sup>-1</sup>
              , (mainly for plantation maintenance), yielding a net profit of
              Rs.2,74,658 ha<sup>-1</sup> yr.<sup>-1</sup>. On the contrary, for
              the catchment of seasonal streams (where both plantation and rice
              fields were considered for income calculation),the average gross
              income generated was Rs. 1,50,679 ha<sup>-1</sup> yr.<sup>-1</sup>{" "}
              against the expenditure of Rs. 6474.10 ha<sup>-1</sup> yr.
              <sup>-1</sup> for plantation maintenance and field
              preparation(Ramachandra et al. 2020b).&nbsp;&nbsp;&nbsp;&nbsp;
            </p>
            <h5>Energy</h5>
            <p>
              The Western Ghats region's energy prospects have been analyzed for
              renewable energy potentials such as solar, wind, and bioenergy.
              Global data signifying solar and photovoltaic PV power potential
              has been collected using consistent high-resolution data layers
              from the ESMAP portal(ESMAP 2020). The long-term energy
              availability of solar resource potential has been estimated from
              global horizontal irradiation (GHI) for the region. GHI integrates
              direct and diffuse irradiation components received by a horizontal
              surface in kilowatt-hours per square meter (kWh/m2).The entire
              Western Ghats region has good solar potential (&gt;5 kWh/m2),
              except for some of the grids of Kerala (Kottayam, Idukki,
              Ernakulam) high-altitude regions (Ramachandra et al. 2016a). Wind
              energy is a cost-effective and clean fuel source and another form
              of solar energy. The wind energy potential was analysed from the
              global wind atlas database based on high-quality and
              high-resolution average wind speed data measured at m/s-meters per
              second (available at 10 m, 50 m, 100 m, 200 m). The data shows the
              region's eastern part has higher potential (&gt;3.5 m/s), and the
              central and southern parts depict moderate potential. Bioenergy
              includes many potential feedstocks, conversion processes, and
              energy applications, easily integrated with existing
              infrastructure. It associates strongly with the agriculture,
              forestry, and waste management sectors, and its prospects are
              linked to the growth of a broader bio-economy. Bioenergy can be
              supplied and used sustainably, contributing to climate change
              mitigation(Ramachandra et al. 2014).Bioenergy potential was
              assessed to reduce or remove the impact of GHG-intensive fuels on
              the environment. The northern Western Ghats region grids have more
              potential than the southern Western Ghats.
            </p>
            <h5>Social aspects</h5>
            <p>
              Uncontrolled population growth in forest landscapes induces the
              exploitation of forest natural resources for numerous purposes,
              which will have irreversible changes on forest structure, causing
              an imbalance in the carrying capacity of forest resources (Misra
              et al. 2014). The rapid population growth will force forest
              degradation, increase resource consumption inequality, and
              intensify waste production, emissions, and pollution (Mote et al.
              2020). The population density for the Western Ghats region has
              been analysed. The Western Ghats regions in Maharashtra and Kerala
              depict higher population pressure than the central Western Ghats
              (Karnataka).&nbsp; Tribal communities are primitive traits having
              distinctive culture, and geographical isolation, which play a
              critical role in forest protection. Tribal groups like the
              Soligas, Kunubis, Gowlis, etc., are native to the Western Ghats
              forests.
            </p>
            <h5>Estuary</h5>
            <p>
              Estuaries are highly dynamic and productive ecosystems in the
              transition between freshwater with the tidal influence generating
              salinity gradients. These ecosystems are endowed with a variety of
              habitats, and the open coast has diverse ecological communities of
              plants and animals. The ecological importance and services of the
              estuaries formed by west-flowing rivers were assessed based on the
              ongoing research in the West Coast and literature review(Nakhawa
              et al. 2017; Ramachandra et al. 2019c; Karthik et al. 2020).
            </p>
            <h5>Ecological significance and the need for conservation</h5>
            <p>
              Ecological sensitivity at disaggregated levels is assessed
              grid-wise by aggregating weights of various themes. Grids are
              grouped into four distinct groups based on the frequency
              distribution of aggregated scores: ESR 1 (aggregated scores &gt;
              &micro;+2&sigma;), ESR 2 (for grids within &micro;+2&sigma; and
              &micro;+&sigma;), ESR 3 (for grids with &micro;+&sigma; and
              &micro;), and ESR 4 (grids with values &lt; &micro;). The analysis
              highlights that the 755 grids covering an area of&nbsp; 32.4% are
              under ESR-1, 373 grids covering 16% are in ESR-2, and 789 grids
              (34% spatial extent) in ESR-3,412 grids covering17.7% area are in
              ESR-4. Regions or Grids corresponding to &nbsp;ESR-1 and 2
              represent ecologically fragile regions with the highest degrees of
              vulnerability and are endowed with rich natural resources and
              higher biodiversity that sustains people&rsquo;s livelihood. ESR-3
              depicts moderate sensitivity, whereas&nbsp; ESR-4 demarcates the
              grids of the least ecological significance with the least resource
              availability. State-wise analyses highlight that Southern states
              such as&nbsp; Kerala, and &nbsp;Karnataka, located in the
              latitudinal gradient of 8 -14&deg; of the Western Ghats with the
              higher composition of endemic and threatened taxa, cover a wider
              spatial extent in ESR-1, and 2 regions. The major part of
              Maharashtra and Tamil Nadu state landscapes are in ESR-3, and 4.
              Figure 6 depicts ESRs at the village level. State-wise,
              village-level ESR analyses presented in Table 1, and Figure
              7indicate that there are (i)345 ecologically vulnerable villages
              (of 1037 villages) in Gujarat state, (ii) 2311, and 2900 villages
              under ESR-1, and 2 in Maharashtra State, (iii)771, and 1111
              villages (of 4911 villages) under ESR-1 and ESR-2 in Karnataka,
              &nbsp;(iv) 163, and 49 villages (of 841 villages in the Western
              Ghats) under ESR-1, 2 in Kerala, 261, and &nbsp;(v) 144 villages
              (of 1407 villages) under ESR-1, and&nbsp; 2 in&nbsp; &nbsp;Tamil
              Nadu.
            </p>
            <p style={{ textAlign: "center" }}>
              {" "}
              <img src="images/wgb6.png" alt="" />{" "}
            </p>

            <p style={{ textAlign: "center" }}>
              Figure 6. Grid wise and village wise ESRs of the Western Ghats
            </p>
            <p style={{ textAlign: "center" }}>
              {" "}
              <img src="images/wgb7.png" alt="" />{" "}
            </p>

            <p style={{ textAlign: "center" }}>
              Figure 7. State-wise ESR distribution of villages that are part of
              the Western Ghats
            </p>
            <p>&nbsp;</p>
            <p>Table 1. State-wise distribution of ESRs</p>
            <table align="center" width="100%">
              <tbody>
                <tr>
                  <td style={styles.cell} rowspan="2" width="13%">
                    <p>
                      <strong>State Name</strong>
                    </p>
                  </td>
                  <td style={styles.cell} rowspan="2" width="13%">
                    <p>
                      <strong>
                        Total Area Km<sup>2</sup>
                      </strong>
                    </p>
                  </td>
                  <td style={styles.cell} colspan="2" width="18%">
                    <p>
                      <strong>ESR-1</strong>
                    </p>
                  </td>
                  <td style={styles.cell} colspan="2" width="18%">
                    <p>
                      <strong>ESR-2</strong>
                    </p>
                  </td>
                  <td style={styles.cell} colspan="2" width="18%">
                    <p>
                      <strong>ESR-3</strong>
                    </p>
                  </td>
                  <td style={styles.cell} colspan="2" width="18%">
                    <p>
                      <strong>ESR-4</strong>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="9%">
                    <p>
                      <strong>
                        Km<sup>2</sup>
                      </strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="9%">
                    <p>
                      <strong>%</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="9%">
                    <p>
                      <strong>
                        Km<sup>2</sup>
                      </strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="9%">
                    <p>
                      <strong>%</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="9%">
                    <p>
                      <strong>
                        Km<sup>2</sup>
                      </strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="9%">
                    <p>
                      <strong>%</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="9%">
                    <p>
                      <strong>
                        Km<sup>2</sup>
                      </strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="9%">
                    <p>
                      <strong>%</strong>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="13%">
                    <p>Gujarat</p>
                  </td>
                  <td style={styles.cell} width="13%">
                    <p>6045</p>
                  </td>
                  <td style={styles.cell} width="9%">
                    <p>2160</p>
                  </td>
                  <td style={styles.cell} width="9%">
                    <p>36</p>
                  </td>
                  <td style={styles.cell} width="9%">
                    <p>1552</p>
                  </td>
                  <td style={styles.cell} width="9%">
                    <p>26</p>
                  </td>
                  <td style={styles.cell} width="9%">
                    <p>1126</p>
                  </td>
                  <td style={styles.cell} width="9%">
                    <p>19</p>
                  </td>
                  <td style={styles.cell} width="9%">
                    <p>1208</p>
                  </td>
                  <td style={styles.cell} width="9%">
                    <p>20</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="13%">
                    <p>Goa</p>
                  </td>
                  <td style={styles.cell} width="13%">
                    <p>2409</p>
                  </td>
                  <td style={styles.cell} width="9%">
                    <p>1267</p>
                  </td>
                  <td style={styles.cell} width="9%">
                    <p>53</p>
                  </td>
                  <td style={styles.cell} width="9%">
                    <p>686</p>
                  </td>
                  <td style={styles.cell} width="9%">
                    <p>28</p>
                  </td>
                  <td style={styles.cell} width="9%">
                    <p>410</p>
                  </td>
                  <td style={styles.cell} width="9%">
                    <p>17</p>
                  </td>
                  <td style={styles.cell} width="9%">
                    <p>47</p>
                  </td>
                  <td style={styles.cell} width="9%">
                    <p>2</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="13%">
                    <p>Karnataka</p>
                  </td>
                  <td style={styles.cell} width="13%">
                    <p>42021</p>
                  </td>
                  <td style={styles.cell} width="9%">
                    <p>23277</p>
                  </td>
                  <td style={styles.cell} width="9%">
                    <p>55</p>
                  </td>
                  <td style={styles.cell} width="9%">
                    <p>7123</p>
                  </td>
                  <td style={styles.cell} width="9%">
                    <p>17</p>
                  </td>
                  <td style={styles.cell} width="9%">
                    <p>8779</p>
                  </td>
                  <td style={styles.cell} width="9%">
                    <p>21</p>
                  </td>
                  <td style={styles.cell} width="9%">
                    <p>2842</p>
                  </td>
                  <td style={styles.cell} width="9%">
                    <p>7</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="13%">
                    <p>Kerala</p>
                  </td>
                  <td style={styles.cell} width="13%">
                    <p>26240</p>
                  </td>
                  <td style={styles.cell} width="9%">
                    <p>13401</p>
                  </td>
                  <td style={styles.cell} width="9%">
                    <p>51</p>
                  </td>
                  <td style={styles.cell} width="9%">
                    <p>1483</p>
                  </td>
                  <td style={styles.cell} width="9%">
                    <p>6</p>
                  </td>
                  <td style={styles.cell} width="9%">
                    <p>5453</p>
                  </td>
                  <td style={styles.cell} width="9%">
                    <p>21</p>
                  </td>
                  <td style={styles.cell} width="9%">
                    <p>5904</p>
                  </td>
                  <td style={styles.cell} width="9%">
                    <p>23</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="13%">
                    <p>Maharashtra</p>
                  </td>
                  <td style={styles.cell} width="13%">
                    <p>60323</p>
                  </td>
                  <td style={styles.cell} width="9%">
                    <p>12958</p>
                  </td>
                  <td style={styles.cell} width="9%">
                    <p>21</p>
                  </td>
                  <td style={styles.cell} width="9%">
                    <p>14668</p>
                  </td>
                  <td style={styles.cell} width="9%">
                    <p>24</p>
                  </td>
                  <td style={styles.cell} width="9%">
                    <p>28710</p>
                  </td>
                  <td style={styles.cell} width="9%">
                    <p>48</p>
                  </td>
                  <td style={styles.cell} width="9%">
                    <p>3987</p>
                  </td>
                  <td style={styles.cell} width="9%">
                    <p>7</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="13%">
                    <p>Tamil Nadu</p>
                  </td>
                  <td style={styles.cell} width="13%">
                    <p>22961</p>
                  </td>
                  <td style={styles.cell} width="9%">
                    <p>10085</p>
                  </td>
                  <td style={styles.cell} width="9%">
                    <p>44</p>
                  </td>
                  <td style={styles.cell} width="9%">
                    <p>2135</p>
                  </td>
                  <td style={styles.cell} width="9%">
                    <p>9</p>
                  </td>
                  <td style={styles.cell} width="9%">
                    <p>4013</p>
                  </td>
                  <td style={styles.cell} width="9%">
                    <p>17</p>
                  </td>
                  <td style={styles.cell} width="9%">
                    <p>6728</p>
                  </td>
                  <td style={styles.cell} width="9%">
                    <p>29</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="13%">
                    <p>&nbsp;</p>
                  </td>
                  <td style={styles.cell} width="13%">
                    <p>160000</p>
                  </td>
                  <td style={styles.cell} width="9%">
                    <p>63148</p>
                  </td>
                  <td style={styles.cell} width="9%">
                    <p>39</p>
                  </td>
                  <td style={styles.cell} width="9%">
                    <p>27646</p>
                  </td>
                  <td style={styles.cell} width="9%">
                    <p>17</p>
                  </td>
                  <td style={styles.cell} width="9%">
                    <p>48490</p>
                  </td>
                  <td style={styles.cell} width="9%">
                    <p>30</p>
                  </td>
                  <td style={styles.cell} width="9%">
                    <p>20716</p>
                  </td>
                  <td style={styles.cell} width="9%">
                    <p>13</p>
                  </td>
                </tr>
              </tbody>
            </table>
            <p>&nbsp;</p>
            <p>
              ESR-1 and 2 signify highly vulnerable and fragile region with a
              high degree of ecological sensitivity and are endowed with rich
              ecology (evident from the distribution of endemic and threatened
              species of biodiversity), hydrological regime (occurrence of
              perennial streams supporting agriculture and horticulture with
              higher productivity) and an array of ecosystem services including
              the provision of diverse food and medicine sustains people&rsquo;s
              livelihood. ESR-3 depicts moderate sensitivity, ESR-4 with the
              least sensitivity, and cluster-based developmental projects based
              on the natural resources available in the region are to be
              implemented to benefit local people.ESR-1 and 2 are ecologically
              susceptible regions with higher ecological fragility; hence, the
              region's ecological integrity needs to be preserved without
              anthropogenic interventions. These regions have demonstrated their
              utility by (i) supporting the livelihood of people through the
              sustenance of water (due to the presence of perennial streams),
              (ii) the presence of diverse pollinators resulting in efficient
              pollination leading to higher crop productivity, (iii) lower
              instances of mudslides, and landslides (as roots of diverse
              vegetation provide binding of soil) and hence ESR1 and ESR 2 are
              to be considered as restricted (no-go) areas for any large scale
              developmental activities. Only environmentally friendly
              initiatives, listed in Table 2 that benefit local people be taken
              up.&nbsp;&nbsp;
            </p>
            <p>
              The ESR framework proposed here forms a foundation for
              conservation and facilitates addressing the various developmental
              issues through an established scientific basis.{" "}
              <em>
                Western Ghats Spatial Decision Support System (WGSDSS) has been
                designed and implemented (Figure 8,
                https://wgbis.ces.iisc.ac.in/sdss/wgsdss/index.php).{" "}
              </em>
            </p>
            <p style={{ textAlign: "center" }}>
              {" "}
              <img src="images/wgb8.png" alt="" />{" "}
            </p>
            <p style={{ textAlign: "center" }}>
              {" "}
              <img src="images/wgb8.png" alt="" />{" "}
            </p>

            <p style={{ textAlign: "center" }}>
              Figure 8. Western Ghats Spatial Decision Support System for
              visualizing ESRs at Village level
            </p>
            <p>&nbsp;</p>
            <p>
              <em>WGSDSS helps </em>in (i) visualizing regions based on
              eco-sensitiveness, (ii) visualizing variables used for computing
              eco-sensitiveness at grid level (5&rsquo;x5&rsquo; or 9 km x 9 km)
              and village levels and (ii) aids in decision making at
              decentralized levels (BMC, local forest department, etc.).
              Understanding ecological sensitiveness at disaggregated levels
              aids in evolving sustainable developmental plans with minimal
              unplanned developmental activities, which helps in conserving
              ecologically susceptible regions.
            </p>
            <p>
              Table 2. Activities that could be allowed and restricted across
              ESRs
            </p>
            <table align="center">
              <tbody>
                <tr>
                  <td style={styles.cell} rowspan="2" width="42">
                    <p>
                      <strong>SNO</strong>
                    </p>
                  </td>
                  <td style={styles.cell} rowspan="2" width="183">
                    <p>
                      <strong>ACTIVITIES</strong>
                    </p>
                  </td>
                  <td style={styles.cell} colspan="4" width="392">
                    <p>
                      <strong>Ecological Sensitive Regions</strong>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="53">
                    <p>
                      <strong>ESR-1</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="79">
                    <p>
                      <strong>ESR-2</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="120">
                    <p>
                      <strong>ESR-3</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="140">
                    <p>
                      <strong>ESR-4</strong>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} rowspan="9" width="42">
                    <p>1</p>
                  </td>
                  <td style={styles.cell} width="183">
                    <p>
                      <strong>ENERGY</strong>
                    </p>
                  </td>
                  <td style={styles.cell} rowspan="2" width="53">
                    <p>
                      <strong>&#10003;</strong>
                    </p>
                  </td>
                  <td style={styles.cell} rowspan="2" width="79">
                    <p>
                      <strong>&#10003;</strong>
                    </p>
                  </td>
                  <td style={styles.cell} rowspan="2" width="120">
                    <p>
                      <strong>&#10003;</strong>
                    </p>
                  </td>
                  <td style={styles.cell} rowspan="2" width="140">
                    <p>
                      <strong>&#10003;</strong>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="183">
                    <p>
                      a)&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Solar (Rooftop)
                    </p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="183">
                    <p>b)&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Wind power</p>
                  </td>
                  <td style={styles.cell} width="53">
                    <p>&#10007;</p>
                  </td>
                  <td style={styles.cell} width="79">
                    <p>
                      <strong>&#10003;</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="120">
                    <p>
                      <strong>&#10003;</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="140">
                    <p>
                      <strong>&#10003;</strong>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="183">
                    <p>c)&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Bioenergy</p>
                  </td>
                  <td style={styles.cell} width="53">
                    <p>&#10007;</p>
                  </td>
                  <td style={styles.cell} width="79">
                    <p>
                      <strong>&#10003;</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="120">
                    <p>
                      <strong>&#10003;</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="140">
                    <p>
                      <strong>&#10003;</strong>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="183">
                    <p>
                      d)&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Coal-based (Thermal
                      power)
                    </p>
                  </td>
                  <td style={styles.cell} width="53">
                    <p>&#10007;</p>
                  </td>
                  <td style={styles.cell} width="79">
                    <p>&#10007;</p>
                  </td>
                  <td style={styles.cell} width="120">
                    <p>&#10007;</p>
                  </td>
                  <td style={styles.cell} width="140">
                    <p>&#10007;</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="183">
                    <p>
                      e)&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Gas or liquid
                      fuel-based
                    </p>
                  </td>
                  <td style={styles.cell} width="53">
                    <p>&#10007;</p>
                  </td>
                  <td style={styles.cell} width="79">
                    <p>&#10007;</p>
                  </td>
                  <td style={styles.cell} width="120">
                    <p>&#10007;</p>
                  </td>
                  <td style={styles.cell} width="140">
                    <p>
                      <strong>&#10003;</strong>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="183">
                    <p>
                      f)&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Hydropower
                      (Major)
                    </p>
                  </td>
                  <td style={styles.cell} width="53">
                    <p>&#10007;</p>
                  </td>
                  <td style={styles.cell} width="79">
                    <p>&#10007;</p>
                  </td>
                  <td style={styles.cell} width="120">
                    <p>&#10007;</p>
                  </td>
                  <td style={styles.cell} width="140">
                    <p>&#10007;</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="183">
                    <p>
                      g)&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Hydropower (Micro)
                    </p>
                  </td>
                  <td style={styles.cell} width="53">
                    <p>&#10007;</p>
                  </td>
                  <td style={styles.cell} width="79">
                    <p>&#10007;</p>
                  </td>
                  <td style={styles.cell} width="120">
                    <p>&#10007;</p>
                  </td>
                  <td style={styles.cell} width="140">
                    <p>
                      <strong>&#10003;</strong>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="183">
                    <p>h)&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Nuclear power</p>
                  </td>
                  <td style={styles.cell} width="53">
                    <p>&#10007;</p>
                  </td>
                  <td style={styles.cell} width="79">
                    <p>&#10007;</p>
                  </td>
                  <td style={styles.cell} width="120">
                    <p>&#10007;</p>
                  </td>
                  <td style={styles.cell} width="140">
                    <p>&#10007;</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} rowspan="6" width="42">
                    <p>2</p>
                  </td>
                  <td style={styles.cell} width="183">
                    <p>
                      <strong>FORESTS</strong>
                    </p>
                  </td>
                  <td style={styles.cell} rowspan="2" width="53">
                    <p>&#10007;</p>
                  </td>
                  <td style={styles.cell} rowspan="2" width="79">
                    <p>&#10007;</p>
                  </td>
                  <td style={styles.cell} rowspan="2" width="120">
                    <p>&#10007;</p>
                  </td>
                  <td style={styles.cell} rowspan="2" width="140">
                    <p>&#10007;</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="183">
                    <p>
                      a)&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Land-use changes
                      (Forest to non-forest usages)
                    </p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="183">
                    <p>
                      b)&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Monoculture
                      plantations
                    </p>
                  </td>
                  <td style={styles.cell} width="53">
                    <p>&#10007;</p>
                  </td>
                  <td style={styles.cell} width="79">
                    <p>&#10007;</p>
                  </td>
                  <td style={styles.cell} width="120">
                    <p>&#10007;</p>
                  </td>
                  <td style={styles.cell} width="140">
                    <p>&#10007;</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="183">
                    <p>
                      c)&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Extraction of
                      medicinal plants (with strict regulations)
                    </p>
                  </td>
                  <td style={styles.cell} width="53">
                    <p>&#10007;</p>
                  </td>
                  <td style={styles.cell} width="79">
                    <p>&#10007;</p>
                  </td>
                  <td style={styles.cell} width="120">
                    <p>
                      <strong>&#10003;</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="140">
                    <p>
                      <strong>&#10003;</strong>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="183">
                    <p>
                      d)&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Forest improvement
                      through VFCs
                    </p>
                  </td>
                  <td style={styles.cell} width="53">
                    <p>
                      <strong>&#10003;</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="79">
                    <p>
                      <strong>&#10003;</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="120">
                    <p>
                      <strong>&#10003;</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="140">
                    <p>
                      <strong>&#10003;</strong>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="183">
                    <p>
                      e)&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; NTFP collection
                    </p>
                  </td>
                  <td style={styles.cell} width="53">
                    <p>
                      <strong>&#10003;</strong>(Strict regulation)
                    </p>
                  </td>
                  <td style={styles.cell} width="79">
                    <p>
                      <strong>&#10003;</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="120">
                    <p>
                      <strong>&#10003;</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="140">
                    <p>
                      <strong>&#10003;</strong>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} rowspan="6" width="42">
                    <p>3</p>
                  </td>
                  <td style={styles.cell} width="183">
                    <p>
                      <strong>AGRICULTURE</strong>
                    </p>
                  </td>
                  <td style={styles.cell} rowspan="2" width="53">
                    <p>
                      <strong>&#10003;</strong>
                    </p>
                  </td>
                  <td style={styles.cell} rowspan="2" width="79">
                    <p>
                      <strong>&#10003;</strong>
                    </p>
                  </td>
                  <td style={styles.cell} rowspan="2" width="120">
                    <p>
                      <strong>&#10003;</strong>
                    </p>
                  </td>
                  <td style={styles.cell} rowspan="2" width="140">
                    <p>
                      <strong>&#10003;</strong>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="183">
                    <p>a)&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Agroforestry</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="183">
                    <p>
                      b)&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Organic farming
                    </p>
                  </td>
                  <td style={styles.cell} width="53">
                    <p>
                      <strong>&#10003;</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="79">
                    <p>
                      <strong>&#10003;</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="120">
                    <p>
                      <strong>&#10003;</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="140">
                    <p>
                      <strong>&#10003;</strong>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="183">
                    <p>
                      c)&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Land-use change /
                      Encroachments
                    </p>
                  </td>
                  <td style={styles.cell} width="53">
                    <p>&#10007;</p>
                  </td>
                  <td style={styles.cell} width="79">
                    <p>&#10007;</p>
                  </td>
                  <td style={styles.cell} width="120">
                    <p>&#10007;</p>
                  </td>
                  <td style={styles.cell} width="140">
                    <p>&#10007;</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="183">
                    <p>
                      d)&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Genetically
                      modified crops
                    </p>
                  </td>
                  <td style={styles.cell} width="53">
                    <p>&#10007;</p>
                  </td>
                  <td style={styles.cell} width="79">
                    <p>&#10007;</p>
                  </td>
                  <td style={styles.cell} width="120">
                    <p>&#10007;</p>
                  </td>
                  <td style={styles.cell} width="140">
                    <p>&#10007;</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="183">
                    <p>
                      e)&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Animal Husbandry
                    </p>
                  </td>
                  <td style={styles.cell} width="53">
                    <p>
                      <strong>&#10003;</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="79">
                    <p>
                      <strong>&#10003;</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="120">
                    <p>
                      <strong>&#10003;</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="140">
                    <p>
                      <strong>&#10003;</strong>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} rowspan="7" width="42">
                    <p>4</p>
                  </td>
                  <td style={styles.cell} width="183">
                    <p>
                      <strong>HORTICULTURE</strong>
                    </p>
                  </td>
                  <td style={styles.cell} rowspan="2" width="53">
                    <p>
                      <strong>&#10003;</strong>
                    </p>
                  </td>
                  <td style={styles.cell} rowspan="2" width="79">
                    <p>
                      <strong>&#10003;</strong>
                    </p>
                  </td>
                  <td style={styles.cell} rowspan="2" width="120">
                    <p>
                      <strong>&#10003;</strong>
                    </p>
                  </td>
                  <td style={styles.cell} rowspan="2" width="140">
                    <p>
                      <strong>&#10003;</strong>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="183">
                    <p>
                      a)&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Organic farming
                    </p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="183">
                    <p>
                      b)&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Nitrogen and
                      Phosphorus (NandP) fertilizers
                    </p>
                  </td>
                  <td style={styles.cell} width="53">
                    <p>&#10007;</p>
                  </td>
                  <td style={styles.cell} width="79">
                    <p>&#10007;</p>
                  </td>
                  <td style={styles.cell} width="120">
                    <p>&#10007;</p>
                  </td>
                  <td style={styles.cell} width="140">
                    <p>
                      <strong>&#10003;</strong>Dosage as prescribed by
                      Agriculture department
                    </p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="183">
                    <p>c)&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Endosulfan</p>
                  </td>
                  <td style={styles.cell} width="53">
                    <p>&#10007;</p>
                  </td>
                  <td style={styles.cell} width="79">
                    <p>&#10007;</p>
                  </td>
                  <td style={styles.cell} width="120">
                    <p>&#10007;</p>
                  </td>
                  <td style={styles.cell} width="140">
                    <p>&#10007;</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="183">
                    <p>d)&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Pesticide</p>
                  </td>
                  <td style={styles.cell} width="53">
                    <p>&#10007;</p>
                  </td>
                  <td style={styles.cell} width="79">
                    <p>&#10007;</p>
                  </td>
                  <td style={styles.cell} width="120">
                    <p>&#10007;</p>
                  </td>
                  <td style={styles.cell} width="140">
                    <p>
                      <strong>&#10003;</strong>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="183">
                    <p>
                      e)&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Watermelon and
                      Muskmelon farming
                    </p>
                  </td>
                  <td style={styles.cell} width="53">
                    <p>&#10007;</p>
                  </td>
                  <td style={styles.cell} width="79">
                    <p>
                      <strong>&#10003;</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="120">
                    <p>
                      <strong>&#10003;</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="140">
                    <p>
                      <strong>&#10003;</strong>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="183">
                    <p>
                      f)&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Ginger
                      cultivation
                    </p>
                  </td>
                  <td style={styles.cell} width="53">
                    <p>&#10007;</p>
                  </td>
                  <td style={styles.cell} width="79">
                    <p>
                      <strong>&#10003;</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="120">
                    <p>
                      <strong>&#10003;</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="140">
                    <p>
                      <strong>&#10003;</strong>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} rowspan="6" width="42">
                    <p>5</p>
                  </td>
                  <td style={styles.cell} width="183">
                    <p>
                      <strong>INDUSTRIES (Large scale)</strong>
                    </p>
                  </td>
                  <td style={styles.cell} rowspan="2" width="53">
                    <p>
                      <strong>&#10003;</strong>
                    </p>
                  </td>
                  <td style={styles.cell} rowspan="2" width="79">
                    <p>
                      <strong>&#10003;</strong>
                    </p>
                  </td>
                  <td style={styles.cell} rowspan="2" width="120">
                    <p>
                      <strong>&#10003;</strong>
                    </p>
                  </td>
                  <td style={styles.cell} rowspan="2" width="140">
                    <p>
                      <strong>&#10003;</strong>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="183">
                    <p>
                      a)&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Agro-processing
                      industries
                    </p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="183">
                    <p>
                      b)&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Information
                      Technology industries (IT)
                    </p>
                  </td>
                  <td style={styles.cell} width="53">
                    <p>&#10007;</p>
                  </td>
                  <td style={styles.cell} width="79">
                    <p>&#10007;</p>
                  </td>
                  <td style={styles.cell} width="120">
                    <p>
                      <strong>&#10003;</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="140">
                    <p>
                      <strong>&#10003;</strong>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="183">
                    <p>
                      c)&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Red category
                      (Polluting) industries
                    </p>
                  </td>
                  <td style={styles.cell} width="53">
                    <p>&#10007;</p>
                  </td>
                  <td style={styles.cell} width="79">
                    <p>&#10007;</p>
                  </td>
                  <td style={styles.cell} width="120">
                    <p>&#10007;</p>
                  </td>
                  <td style={styles.cell} width="140">
                    <p>&#10007;</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="183">
                    <p>
                      d)&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Garment industries
                    </p>
                  </td>
                  <td style={styles.cell} width="53">
                    <p>&#10007;</p>
                  </td>
                  <td style={styles.cell} width="79">
                    <p>&#10007;</p>
                  </td>
                  <td style={styles.cell} width="120">
                    <p>
                      <strong>&#10003;</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="140">
                    <p>
                      <strong>&#10003;</strong>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="183">
                    <p>
                      e)&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; New establishment
                      of Industries
                    </p>
                  </td>
                  <td style={styles.cell} width="53">
                    <p>&#10007;</p>
                  </td>
                  <td style={styles.cell} width="79">
                    <p>&#10007;</p>
                  </td>
                  <td style={styles.cell} width="120">
                    <p>&#10007;</p>
                  </td>
                  <td style={styles.cell} width="140">
                    <p>
                      <strong>&#10003;</strong>(Allowed only after critical
                      review by local stakeholders and experts)
                    </p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="42">
                    <p>&nbsp;</p>
                  </td>
                  <td style={styles.cell} width="183">
                    <p>
                      f)&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Nonpolluting
                      (Green) Industries
                    </p>
                  </td>
                  <td style={styles.cell} width="53">
                    <p>&#10007;</p>
                  </td>
                  <td style={styles.cell} width="79">
                    <p>&#10007;</p>
                  </td>
                  <td style={styles.cell} width="120">
                    <p>
                      <strong>&#10003;</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="140">
                    <p>
                      <strong>&#10003;</strong>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} rowspan="16" width="42">
                    <p>6</p>
                  </td>
                  <td style={styles.cell} width="183">
                    <p>
                      <strong>INDUSTRIES (Small scale)</strong>
                    </p>
                  </td>
                  <td style={styles.cell} rowspan="2" width="53">
                    <p>&#10007;</p>
                  </td>
                  <td style={styles.cell} rowspan="2" width="79">
                    <p>
                      <strong>&#10003;</strong>
                    </p>
                  </td>
                  <td style={styles.cell} rowspan="2" width="120">
                    <p>
                      <strong>&#10003;</strong>
                    </p>
                  </td>
                  <td style={styles.cell} rowspan="2" width="140">
                    <p>
                      <strong>&#10003;</strong>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="183">
                    <p>
                      i.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                      Garment industries
                    </p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="183">
                    <p>
                      ii.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                      Domestic (Home-based) industries
                    </p>
                    <p>a.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Papad</p>
                  </td>
                  <td style={styles.cell} width="53">
                    <p>
                      <strong>&#10003;</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="79">
                    <p>
                      <strong>&#10003;</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="120">
                    <p>
                      <strong>&#10003;</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="140">
                    <p>
                      <strong>&#10003;</strong>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="183">
                    <p>
                      b.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Mango processing
                    </p>
                  </td>
                  <td style={styles.cell} width="53">
                    <p>
                      <strong>&#10003;</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="79">
                    <p>
                      <strong>&#10003;</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="120">
                    <p>
                      <strong>&#10003;</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="140">
                    <p>
                      <strong>&#10003;</strong>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="183">
                    <p>
                      c.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Areca nut
                      processing and Coir industries
                    </p>
                  </td>
                  <td style={styles.cell} width="53">
                    <p>&#10007;</p>
                  </td>
                  <td style={styles.cell} width="79">
                    <p>
                      <strong>&#10003;</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="120">
                    <p>
                      <strong>&#10003;</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="140">
                    <p>
                      <strong>&#10003;</strong>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="183">
                    <p>
                      d.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Milk products and
                      processing
                    </p>
                  </td>
                  <td style={styles.cell} width="53">
                    <p>
                      <strong>&#10003;</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="79">
                    <p>
                      <strong>&#10003;</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="120">
                    <p>
                      <strong>&#10003;</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="140">
                    <p>
                      <strong>&#10003;</strong>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="183">
                    <p>
                      e.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Dry fruits
                      and Spices
                    </p>
                  </td>
                  <td style={styles.cell} width="53">
                    <p>
                      <strong>&#10003;</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="79">
                    <p>
                      <strong>&#10003;</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="120">
                    <p>
                      <strong>&#10003;</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="140">
                    <p>
                      <strong>&#10003;</strong>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="183">
                    <p>
                      f.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Fruit
                      processing (Ex: Kokum Juice <em>(Garcinia indica)</em>)
                    </p>
                  </td>
                  <td style={styles.cell} width="53">
                    <p>
                      <strong>&#10003;</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="79">
                    <p>
                      <strong>&#10003;</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="120">
                    <p>
                      <strong>&#10003;</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="140">
                    <p>
                      <strong>&#10003;</strong>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="183">
                    <p>
                      g.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Fish products
                      processing
                    </p>
                  </td>
                  <td style={styles.cell} width="53">
                    <p>
                      <strong>&#10003;</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="79">
                    <p>
                      <strong>&#10003;</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="120">
                    <p>
                      <strong>&#10003;</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="140">
                    <p>
                      <strong>&#10003;</strong>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="183">
                    <p>
                      h.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Bee keeping and bee
                      nurseries
                    </p>
                  </td>
                  <td style={styles.cell} width="53">
                    <p>
                      <strong>&#10003;</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="79">
                    <p>
                      <strong>&#10003;</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="120">
                    <p>
                      <strong>&#10003;</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="140">
                    <p>
                      <strong>&#10003;</strong>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="183">
                    <p>
                      i.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                      Pongamia plantations for biofuel (in private lands)
                    </p>
                  </td>
                  <td style={styles.cell} width="53">
                    <p>&#10007;</p>
                  </td>
                  <td style={styles.cell} width="79">
                    <p>
                      <strong>&#10003;</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="120">
                    <p>
                      <strong>&#10003;</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="140">
                    <p>
                      <strong>&#10003;</strong>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="183">
                    <p>
                      j.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Bio
                      pesticides manufacturing
                    </p>
                  </td>
                  <td style={styles.cell} width="53">
                    <p>&#10007;</p>
                  </td>
                  <td style={styles.cell} width="79">
                    <p>
                      <strong>&#10003;</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="120">
                    <p>
                      <strong>&#10003;</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="140">
                    <p>
                      <strong>&#10003;</strong>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="183">
                    <p>
                      k.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Poultry farms and
                      powdered eggs
                    </p>
                  </td>
                  <td style={styles.cell} width="53">
                    <p>&#10007;</p>
                  </td>
                  <td style={styles.cell} width="79">
                    <p>
                      <strong>&#10003;</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="120">
                    <p>
                      <strong>&#10003;</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="140">
                    <p>
                      <strong>&#10003;</strong>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="183">
                    <p>
                      l.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                      Vegetable dyes; fruits and vegetables preservation
                    </p>
                  </td>
                  <td style={styles.cell} width="53">
                    <p>
                      <strong>&#10003;</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="79">
                    <p>
                      <strong>&#10003;</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="120">
                    <p>
                      <strong>&#10003;</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="140">
                    <p>
                      <strong>&#10003;</strong>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="183">
                    <p>
                      m.&nbsp;&nbsp;&nbsp;&nbsp; Medicinal plants cultivation
                      and processing
                    </p>
                  </td>
                  <td style={styles.cell} width="53">
                    <p>
                      <strong>&#10003;</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="79">
                    <p>
                      <strong>&#10003;</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="120">
                    <p>
                      <strong>&#10003;</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="140">
                    <p>
                      <strong>&#10003;</strong>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="183">
                    <p>
                      n.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Aromatic plants and
                      essential oil distillation; orchids and cut flowers
                      harvesting industries
                    </p>
                  </td>
                  <td style={styles.cell} width="53">
                    <p>&#10007;</p>
                  </td>
                  <td style={styles.cell} width="79">
                    <p>
                      <strong>&#10003;</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="120">
                    <p>
                      <strong>&#10003;</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="140">
                    <p>
                      <strong>&#10003;</strong>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} rowspan="6" width="42">
                    <p>7</p>
                  </td>
                  <td style={styles.cell} width="183">
                    <p>
                      <strong>TOURISM INDUSTRY</strong>
                    </p>
                  </td>
                  <td style={styles.cell} rowspan="2" width="53">
                    <p>&#10007;</p>
                  </td>
                  <td style={styles.cell} rowspan="2" width="79">
                    <p>
                      <strong>&#10003;</strong>
                    </p>
                  </td>
                  <td style={styles.cell} rowspan="2" width="120">
                    <p>
                      <strong>&#10003;</strong>
                    </p>
                  </td>
                  <td style={styles.cell} rowspan="2" width="140">
                    <p>
                      <strong>&#10003;</strong>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="183">
                    <p>a)&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Ecotourism</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="183">
                    <p>
                      b)&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Organic village and
                      homestay
                    </p>
                  </td>
                  <td style={styles.cell} width="53">
                    <p>
                      <strong>&#10003;</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="79">
                    <p>
                      <strong>&#10003;</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="120">
                    <p>
                      <strong>&#10003;</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="140">
                    <p>
                      <strong>&#10003;</strong>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="183">
                    <p>
                      c)&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; VFC managed tourism
                    </p>
                  </td>
                  <td style={styles.cell} width="53">
                    <p>
                      <strong>&#10003;</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="79">
                    <p>
                      <strong>&#10003;</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="120">
                    <p>
                      <strong>&#10003;</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="140">
                    <p>
                      <strong>&#10003;</strong>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="183">
                    <p>
                      d)&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; VFC managed
                      homestay tourism in higher forest cover regions and
                      protected areas
                    </p>
                  </td>
                  <td style={styles.cell} width="53">
                    <p>&#10007;</p>
                  </td>
                  <td style={styles.cell} width="79">
                    <p>
                      <strong>&#10003;</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="120">
                    <p>
                      <strong>&#10003;</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="140">
                    <p>
                      <strong>&#10003;</strong>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="183">
                    <p>
                      e)&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Arts and
                      handicrafts museum and trade center
                    </p>
                  </td>
                  <td style={styles.cell} width="53">
                    <p>
                      <strong>&#10003;</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="79">
                    <p>
                      <strong>&#10003;</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="120">
                    <p>
                      <strong>&#10003;</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="140">
                    <p>
                      <strong>&#10003;</strong>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} rowspan="7" width="42">
                    <p>8</p>
                  </td>
                  <td style={styles.cell} width="183">
                    <p>
                      <strong>MINING AND MINERAL EXTRACTION</strong>
                    </p>
                  </td>
                  <td style={styles.cell} rowspan="2" width="53">
                    <p>&nbsp;</p>
                    <p>&#10007;</p>
                  </td>
                  <td style={styles.cell} rowspan="2" width="79">
                    <p>&nbsp;</p>
                    <p>&#10007;</p>
                  </td>
                  <td style={styles.cell} rowspan="2" width="120">
                    <p>&nbsp;</p>
                    <p>&#10007;</p>
                  </td>
                  <td style={styles.cell} rowspan="2" width="140">
                    <p>&nbsp;</p>
                    <p>&#10007;</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="183">
                    <p>a)&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Iron ore</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="183">
                    <p>b)&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Manganese</p>
                  </td>
                  <td style={styles.cell} width="53">
                    <p>&#10007;</p>
                  </td>
                  <td style={styles.cell} width="79">
                    <p>&#10007;</p>
                  </td>
                  <td style={styles.cell} width="120">
                    <p>&#10007;</p>
                  </td>
                  <td style={styles.cell} width="140">
                    <p>&#10007;</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="183">
                    <p>c)&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Bauxite</p>
                  </td>
                  <td style={styles.cell} width="53">
                    <p>&#10007;</p>
                  </td>
                  <td style={styles.cell} width="79">
                    <p>&#10007;</p>
                  </td>
                  <td style={styles.cell} width="120">
                    <p>&#10007;</p>
                  </td>
                  <td style={styles.cell} width="140">
                    <p>&#10007;</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="183">
                    <p>d)&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Limestone</p>
                  </td>
                  <td style={styles.cell} width="53">
                    <p>&#10007;</p>
                  </td>
                  <td style={styles.cell} width="79">
                    <p>&#10007;</p>
                  </td>
                  <td style={styles.cell} width="120">
                    <p>&#10007;</p>
                  </td>
                  <td style={styles.cell} width="140">
                    <p>
                      <strong>&#10003;</strong>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="183">
                    <p>e)&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Quartz</p>
                  </td>
                  <td style={styles.cell} width="53">
                    <p>&#10007;</p>
                  </td>
                  <td style={styles.cell} width="79">
                    <p>&#10007;</p>
                  </td>
                  <td style={styles.cell} width="120">
                    <p>&#10007;</p>
                  </td>
                  <td style={styles.cell} width="140">
                    <p>
                      <strong>&#10003;</strong>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="183">
                    <p>
                      f)&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Sand
                      extraction (on sustainable basis by
                    </p>
                    <p>Ban on exporting)</p>
                  </td>
                  <td style={styles.cell} width="53">
                    <p>&#10007;</p>
                  </td>
                  <td style={styles.cell} width="79">
                    <p>&#10007;</p>
                  </td>
                  <td style={styles.cell} width="120">
                    <p>
                      <strong>&#10003;</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="140">
                    <p>
                      <strong>&#10003;</strong>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} rowspan="5" width="42">
                    <p>9</p>
                  </td>
                  <td style={styles.cell} width="183">
                    <p>
                      <strong>WASTE DISPOSAL</strong>
                    </p>
                  </td>
                  <td style={styles.cell} rowspan="2" width="53">
                    <p>&nbsp;</p>
                    <p>&#10007;</p>
                  </td>
                  <td style={styles.cell} rowspan="2" width="79">
                    <p>&nbsp;</p>
                    <p>&#10007;</p>
                  </td>
                  <td style={styles.cell} rowspan="2" width="120">
                    <p>&nbsp;</p>
                    <p>&#10007;</p>
                  </td>
                  <td style={styles.cell} rowspan="2" width="140">
                    <p>&nbsp;</p>
                    <p>&#10007;</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="183">
                    <p>
                      a)&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Hazardous waste
                      processing units
                    </p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="183">
                    <p>
                      b)&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Solid waste
                      disposal
                    </p>
                  </td>
                  <td style={styles.cell} width="53">
                    <p>&#10007;</p>
                  </td>
                  <td style={styles.cell} width="79">
                    <p>&#10007;</p>
                  </td>
                  <td style={styles.cell} width="120">
                    <p>&#10007;</p>
                  </td>
                  <td style={styles.cell} width="140">
                    <p>
                      <strong>&#10003;</strong>(For composting and manure
                      preparation)
                    </p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="183">
                    <p>
                      c)&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Liquid waste
                      discharge
                    </p>
                  </td>
                  <td style={styles.cell} width="53">
                    <p>&#10007;</p>
                  </td>
                  <td style={styles.cell} width="79">
                    <p>&#10007;</p>
                  </td>
                  <td style={styles.cell} width="120">
                    <p>&#10007;</p>
                  </td>
                  <td style={styles.cell} width="140">
                    <p>
                      <strong>&#10003;</strong>(Treatment plants (STP) for
                      processing)
                    </p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="183">
                    <p>
                      d)&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Recycling and waste
                      processing and units
                    </p>
                  </td>
                  <td style={styles.cell} width="53">
                    <p>&#10007;</p>
                  </td>
                  <td style={styles.cell} width="79">
                    <p>&#10007;</p>
                  </td>
                  <td style={styles.cell} width="120">
                    <p>&#10007;</p>
                  </td>
                  <td style={styles.cell} width="140">
                    <p>
                      <strong>&#10003;</strong>(compliant with PCB)
                    </p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} rowspan="4" width="42">
                    <p>10</p>
                  </td>
                  <td style={styles.cell} width="183">
                    <p>
                      <strong>TRANSPORTATION</strong>
                    </p>
                  </td>
                  <td style={styles.cell} rowspan="2" width="53">
                    <p>&#10007;</p>
                  </td>
                  <td style={styles.cell} rowspan="2" width="79">
                    <p>&#10007;</p>
                  </td>
                  <td style={styles.cell} rowspan="2" width="120">
                    <p>&#10007;</p>
                  </td>
                  <td style={styles.cell} rowspan="2" width="140">
                    <p>
                      <strong>&#10003;</strong>(Allowed only after strict EIA)
                    </p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="183">
                    <p>
                      a)&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Roads and
                      expressways
                    </p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="183">
                    <p>
                      b)&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Rail and freight
                      corridors
                    </p>
                  </td>
                  <td style={styles.cell} colspan="4" width="392">
                    <p>
                      <strong>
                        Subject to EIA with the strict regulation and social
                        audit
                      </strong>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="183">
                    <p>
                      c)&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Up-gradation of
                      existing infrastructure
                    </p>
                  </td>
                  <td style={styles.cell} width="53">
                    <p>&#10007;</p>
                  </td>
                  <td style={styles.cell} width="79">
                    <p>&#10007;</p>
                  </td>
                  <td style={styles.cell} width="120">
                    <p>
                      <strong>&#10003;</strong>(Subject to
                    </p>
                    <p>EIAs, strict regulation and</p>
                    <p>social audit)</p>
                  </td>
                  <td style={styles.cell} width="140">
                    <p>
                      <strong>&#10003;</strong>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} colspan="6" width="616">
                    <p>
                      <strong>Remarks</strong>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} colspan="6" width="616">
                    <p>
                      &middot;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                      ESR-1 regions are ecologically susceptible, representing a
                      zone of highest conservation, and maintain ecological
                      integrity with no further degradation be allowed. ESR-2
                      has the potential to become ESR-1 provided with strict
                      regulations and improved forests and their environs with
                      more protection. Also, a small change in ESR-2 will have
                      more adverse effects in ESR1.
                    </p>
                    <p>
                      &middot;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                      Linear (new major/ expansion of roads and railway lines)
                      be allowed across the ESR-1 and 2 due to their ecological
                      sensitivity. Essential expansion activities should be
                      subjected to the Environmental Impact Assessment (EIA) and
                      strict monitoring based on the social audit.
                    </p>
                    <p>
                      &middot;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                      Public utilities involving the construction of schools,
                      hospitals, government offices, libraries, and other public
                      amenities (large/small scale) be allowed and subject to
                      strict monitoring with the social audit.
                    </p>
                    <p>
                      &middot;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                      Forest Rights Act to be implemented in its true spirit to
                      support the genuine forest-dwelling communities.
                    </p>
                    <p>
                      &middot;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                      Monoculture plantations should not be allowed, and
                      existing exotics should be replaced by planting endemic
                      species. Fast-growing native trees such as{" "}
                      <em>Madhuca longifolia </em>(Mahua),{" "}
                      <em>Madhuca latifolia</em>,{" "}
                      <em>Melia dubia, Azadirachta indica</em> (Neem),{" "}
                      <em>Terminalia arjuna,</em> etc., could be used, which not
                      only aid in the eco-restoration but help in meeting the
                      local timber requirements in ESR regions.&nbsp;
                    </p>
                    <p>
                      &middot;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                      Monoculture exotic species should be restricted even in
                      coffee plantations of ESR-1.
                    </p>
                    <p>
                      &middot;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                      Promote decentralized electricity generation through
                      location-specific renewable energy sources such as solar,
                      wind, biomass, etc.
                    </p>
                    <p>
                      &middot;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                      Farmers need to be encouraged with incentives for
                      practicing organic farming, agroforestry, beekeeping, etc.
                    </p>
                    <p>
                      &middot;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                      Fruit-yielding tree saplings to be distributed to farmers
                      through decentralized forest nurseries, which would aid as
                      an alternate income source.
                    </p>
                    <p>
                      &middot;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                      The local bio resource-based industry should be promoted.
                      All should be strictly regulated and be subject to social
                      audits.
                    </p>
                    <p>
                      &middot;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                      Adapt environment-friendly development projects and
                      involve local community members in decision-making and
                      ecological monitoring.
                    </p>
                    <p>
                      &middot;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                      The tourism Master Plan should be based on MoEFCC
                      regulations (after considering social and environmental
                      costs). The ban should be imposed on large resort
                      construction and new tourism establishments in ESR-1.
                    </p>
                    <p>
                      &middot;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                      Controlled activities are permitted based on
                      socio-economic importance, and activities such as
                      depriving wetlands and natural forests and introducing
                      alien invasive species are not allowed.
                    </p>
                    <p>
                      &middot;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                      Tribes and indigenous communities should be engaged in the
                      conservation and protection of forests. Tribal women
                      should be employed in the nurseries across the ESRs.
                    </p>
                    <p>
                      &middot;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                      The Western Ghats biodiversity information centers should
                      be established at all the district headquarters of the
                      region to sensitize students and citizens on conservation
                      measures and issues. These centers work towards
                      implementing a comprehensive plan for the protection of
                      fragile ecosystems and livelihoods.
                    </p>
                    <p>
                      &middot;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                      Public hearings and timely consultations with all the
                      stakeholders must be made mandatory for all the
                      largescale/medium-scale projects, including liner
                      projects, to have a collective decision, which will also
                      gain people's opinion, and help in stemming the impacts
                      with alternatives.
                    </p>
                  </td>
                </tr>
              </tbody>
            </table>
            <br />
            <br />
            <hr />
            <br />
          </p>
        </div>
      }
    />
  );
}
export default RADPage;
